import AccessMenu from './dropdown_menu.js';

export default AccessMenu;
